/**
 * Core: Helpers.
 * -----------------------------------------------------------------------------
 * - Helper functions relating to core functionality.
 */
/**
 * Return a dynamic import for a given Vue component
 * @param {String} handle - A given handle for a Vue component.
 * @returns {Object}
 */
import { defineAsyncComponent } from 'vue'

/**
 * Dynamically import a Vue component.
 * @param {String} handle - Unique handle for a component.
 * @returns {Object}
//  * @depreciated - Use lazyLoadComponent instead.
 */
export function importComponent(handle) {
  return defineAsyncComponent({
    loader: () => import(
      /* webpackChunkName: 'component.[request]' */
      `~components/${handle}/${handle}.vue`
    ),
  })
}

// /**
//  * Return a dynamic import for a given Vue component
//  * - Passes through webpackChunkName to ensure compatibility.
//  * @param {String} path - A given file path resolver.
//  * @returns {Object}
//  */
// export function lazyLoadComponent(path) {
//   return defineAsyncComponent({
//     loader: () => import(
//       /* webpackChunkName: 'component.[request]' */
//       `${path}.vue`
//     ),
//   })
// }